/*
 * Created on Tue Jul 30 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import { BehaviorSubject, Observable, Subscription } from "rxjs";
import Vue from "vue";

interface IThemeUnit {
    key: string;
    name: string;
    element: typeof Vue;
}

let themeMap: {
    [index: string]: IThemeUnit;
} = {};

/// key, ex: coreui-blue
/// name, ex: w_VAL_Theme_Blue
export function RegisterTheme(key: string, name: string) {
    return (element: any) => {
        themeMap[key] = {
            key,
            name,
            element,
        };
    };
}

export function retrieveTheme(element: typeof Vue): IThemeUnit | undefined {
    for (let theme in themeMap) {
        let themeUnit = themeMap[theme];
        if (themeUnit.element === element) return themeUnit;
    }
    return;
}

export class Theme {
    static list(): { [index: string]: IThemeUnit } {
        return themeMap;
    }
}
